// extracted by mini-css-extract-plugin
export default {"clinician_button":"clinicianlist_clinician_button__skc9N","name_arrow":"clinicianlist_name_arrow__XWzfO"};